import { BaseError } from '@kiplin/web-common/error';

export class MissingGamesUserClientError extends BaseError {
  public constructor(clientId: string) {
    super(
      '1e9f077a-c51a-42c0-bbd7-9611006ac9c1',
      `CurrentClientUser - Try to access first game for client "${clientId}" but no game is available`,
    );
  }
}
